// Author liang gang qiang
// Date 2021-10-22 14:57:43

class MintalMesMstMaterial {
constructor({
        id = null,
        code = '',
        name = '',
        type = '',
        model = '',
        spec = '',
        unit = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.type = type;
    this.model = model;
    this.spec = spec;
    this.unit = unit;
    this.remark = remark;
}
}

function newEntity() {
return new MintalMesMstMaterial();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.mst.mintalMesMstMaterial.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'code',
        label: 'label.mintal.mst.mintalMesMstMaterial.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.mintal.mst.mintalMesMstMaterial.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'type',
        label: 'label.mintal.mst.mintalMesMstMaterial.grid.type',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '原料类' },
                            { value: '2', text: '辅料类' },
                            { value: '3', text: '还原剂' },
                            { value: '4', text: '熔剂' },
                            { value: '5', text: '工业固废水渣' },
                            { value: '6', text: '半成品' },
                            { value: '7', text: '成品' }
            ]
        }
        },
        {
        key: 'model',
        label: 'label.mintal.mst.mintalMesMstMaterial.grid.model',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spec',
        label: 'label.mintal.mst.mintalMesMstMaterial.grid.spec',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'unit',
        label: 'label.mintal.mst.mintalMesMstMaterial.grid.unit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.mst.mintalMesMstMaterial.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    codeFilter : '',
    nameFilter : '',
    typeFilter : '',
    modelFilter : '',
    specFilter : '',
    unitFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.mintal.mst.mintalMesMstMaterial.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.mintal.mst.mintalMesMstMaterial.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'typeFilter',
        label: 'label.mintal.mst.mintalMesMstMaterial.filter.type',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '原料类' },
                { value: '2', text: '辅料类' },
                { value: '3', text: '还原剂' },
                { value: '4', text: '熔剂' },
                { value: '5', text: '工业固废水渣' },
                { value: '6', text: '半成品' },
                { value: '7', text: '成品' }
            ]
        }
        },
        {
        key: 'modelFilter',
        label: 'label.mintal.mst.mintalMesMstMaterial.filter.model',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'specFilter',
        label: 'label.mintal.mst.mintalMesMstMaterial.filter.spec',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'unitFilter',
        label: 'label.mintal.mst.mintalMesMstMaterial.filter.unit',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.mintal.mst.mintalMesMstMaterial.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'name',
        label: 'label.mintal.mst.mintalMesMstMaterial.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'type',
        label: 'label.mintal.mst.mintalMesMstMaterial.entity.type',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '原料类' },
                { value: '2', text: '辅料类' },
                { value: '3', text: '还原剂' },
                { value: '4', text: '熔剂' },
                { value: '5', text: '工业固废水渣' },
                { value: '6', text: '半成品' },
                { value: '7', text: '成品' }
            ]
        }
        },
        {
        key: 'model',
        label: 'label.mintal.mst.mintalMesMstMaterial.entity.model',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spec',
        label: 'label.mintal.mst.mintalMesMstMaterial.entity.spec',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'unit',
        label: 'label.mintal.mst.mintalMesMstMaterial.entity.unit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.mintal.mst.mintalMesMstMaterial.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {MintalMesMstMaterial, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
